import { useLicense } from '@core/license';
import { useUser } from '@core/user';
/**
 * Retrieves the current license model, and user model with its privileges and access.
 *
 * @deprecated Use useUser from @core/user and useLicense from @core/license instead.
 */ export var useAccessControl = function useAccessControl() {
    var _useUser = useUser(), user = _useUser.access;
    var license = useLicense();
    return {
        user: user,
        license: license
    };
};

//# sourceMappingURL=useAccessControl.js.map